import React, { useEffect, useState } from 'react'
import ImageSlider from './ImageSlider';
import axiosUmbraco from '../axios/axiosUmbraco';
const BaseURL = process.env.REACT_APP_BACKEND_API;

const sliderID = process.env.REACT_APP_SLIDER_ID;

export default function HomePageImageVideo() {

    const [sliderItems, setSliderItems] = useState([]);
    async function getSliders() {
        const response = await axiosUmbraco.get(`umbraco/delivery/api/v2/content?fetch=children:${sliderID}&skip=0&take=1000`)

        const formattedData = response.data.items.map((item) => ({
            type: item.properties.sliderType ? 'img' : 'video',
            link: item.properties.sliderType ? BaseURL + item?.properties?.image[0]?.url ?? '' : item?.properties?.videoLink ?? '',
            title: item?.properties?.title ?? '',
            subTitle: item?.properties?.subTitle ?? '',
            sliderLink: item?.properties?.sliderLink ?? '',
            sort: item?.properties?.sort ?? '',
            isExternalLink: item?.properties?.isExternalLink ?? '',
            publishForWeb: item?.properties?.publishForWeb ?? false,

        }))

        const filtereditems = formattedData.filter((item) => !!item.publishForWeb);
        const sortedItems = filtereditems.sort((a,b) => a.sort - b.sort);

        setSliderItems(sortedItems);
    }


    useEffect(() => {
        getSliders();
    }, [])


    return <ImageSlider items={sliderItems} key={'Slider'} isHomePageSlider={true} autoScroll={true} />

}
